
import { ADD_LIBRARY_REQUEST,ADD_LIBRARY_SUCCESS,ADD_LIBRARY_FAILED,ADD_DISPLAY_FAILED,ADD_DISPLAY_REQUEST,ADD_DISPLAY_SUCCESS, UPLOAD_IMAGE, UPLOAD_SUCCESS, UPLOAD_FAILED, DELETE_IMAGE, DELETE_SUCCESS, DELETE_FAILED, GET_LIBRARY_REQUEST, GET_LIBRARY_SUCCESS, GET_LIBRARY_FAILED, GET_DISPLAY_REQUEST, GET_DISPLAY_SUCCESS, GET_DISPLAY_FAILED, DELETE_DISPLAY, DELETE_DISPLAY_SUCCESS, DELETE_DISPLAY_FAILURE, TEMPLATE_REQUEST, TEMPLATE_SUCCESS, TEMPLATE_FAILED } from "./DisplayConstant";

export const getLibRequest = (data) => ({
  type:GET_LIBRARY_REQUEST,
  payload: data,
});

export const getLibSuccess = (response) => ({
  type: GET_LIBRARY_SUCCESS,
  payload: response,
});

export const getLibFailure = (error) => ({
  type:GET_LIBRARY_FAILED,
  payload: error,
});

export const getDisplayRequest = (data) => ({
  type:GET_DISPLAY_REQUEST,
  payload: data,
});

export const getDisplaySuccess = (response) => ({
  type: GET_DISPLAY_SUCCESS,
  payload: response,
});

export const getDisplayFailure = (error) => ({
  type:GET_DISPLAY_FAILED,
  payload: error,
});




export const adddisplayRequest = (data) => ({
  type:ADD_DISPLAY_REQUEST,
  payload: data,
});

export const adddisplaySuccess = (response) => ({
  type: ADD_DISPLAY_SUCCESS,
  payload: response,
});

export const adddisplayFailure = (error) => ({
  type: ADD_DISPLAY_FAILED,
  payload: error,
});

export const templateRequest = (data) => ({
  type:TEMPLATE_REQUEST,
  payload: data,
});

export const templateDataSuccess = (response) => ({
  type: TEMPLATE_SUCCESS,
  payload: response,
});

export const templateDataFailure = (error) => ({
  type: TEMPLATE_FAILED,
  payload: error,
});



export const uploadImage = (data) => ({
  type:UPLOAD_IMAGE,
  payload: data,
});

export const uploadIndex = (response) => ({
  type: UPLOAD_SUCCESS,
  payload: response,
});

export const uploadSuccess = (response) => ({
  type: UPLOAD_SUCCESS,
  payload: response,
});

export const uploadFailure = (error) => ({
  type: UPLOAD_FAILED,
  payload: error,
});


export const deleteImage = (data) => ({
  type:DELETE_IMAGE,
  payload: data,
});

export const deleteSuccess = (response) => ({
  type: DELETE_SUCCESS,
  payload: response,
});

export const deleteFailure = (error) => ({
  type: DELETE_FAILED,
  payload: error,
});

export const deleteDisplay = (data) => ({
  type:DELETE_DISPLAY,
  payload: data,
});

export const deleteDisplaySuccess = (response) => ({
  type: DELETE_DISPLAY_SUCCESS,
  payload: response,
});

export const deleteDisplayFailure = (error) => ({
  type: DELETE_DISPLAY_FAILURE,
  payload: error,
});